import { create } from "zustand"

// 2026-05-06 — Store del motor activo del Canvas.
//
// Canvas.tsx escribe acá cuando el `gl` factory resuelve. La HUD lee
// el modo y pinta un puntito en top-left:
//   · "webgpu" → punto verde pulsando — motor de máxima conductividad.
//   · "webgl"  → punto azul pulsando — motor clásico, fallback estable.
//   · "unknown" (estado inicial brevísimo entre el mount del Canvas y
//                la resolución del factory async) — sin puntito.
//
// El estado vive aparte del flow del Tripulante para que cualquier
// componente UI pueda consultarlo (HUD, banners de debug, etc.) sin
// tener que conocer el shape interno de R3F.

export type RendererMode = "unknown" | "webgl" | "webgpu"

interface RendererState {
    mode: RendererMode
    setMode: (m: RendererMode) => void
}

export const useRendererStore = create<RendererState>((set) => ({
    mode: "unknown",
    setMode: (mode) => set({ mode }),
}))
